import React from "react"
// ”

export const testimonials = [
  {
    id: "okta",
    order: 1,
    logo: "oktanew.png",
    blueLogo: {
      fallBackImage: "okta_blue_logo.png",
      responsiveImages: [
        {
          imageName: "okta_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "okta_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "okta_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    tSlider: {
      folderName: "spiralyze2024website",
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="18"
          viewBox="0 0 53 18"
          fill="none"
        >
          <g clip-path="url(#clip0_20797_30696)">
            <path
              d="M6.5 5C2.90755 5 0 7.90755 0 11.5C0 15.0924 2.90755 18 6.5 18C10.0924 18 13 15.0924 13 11.5C13 7.90755 10.0924 5 6.5 5ZM6.5 14.7565C4.70378 14.7565 3.24354 13.2962 3.24354 11.5C3.24354 9.70378 4.70378 8.24354 6.5 8.24354C8.29622 8.24354 9.75646 9.70378 9.75646 11.5C9.75646 13.2962 8.29622 14.7565 6.5 14.7565Z"
              fill="white"
            />
            <path
              d="M18.4071 13.5469C18.4071 13.0104 19.0459 12.7556 19.4185 13.1311C21.0955 14.848 23.8637 17.7988 23.877 17.8122C23.9169 17.8525 23.9569 17.9195 24.1166 17.9732C24.1831 18 24.2896 18 24.4094 18H27.4305C27.9761 18 28.1359 17.3696 27.883 17.0477L22.8789 11.8838L22.6127 11.6155C22.0404 10.9314 22.1069 10.6632 22.7591 9.96572L26.7251 5.49925C26.978 5.17735 26.8183 4.56036 26.2593 4.56036H23.5177C23.4112 4.56036 23.3314 4.56036 23.2515 4.58718C23.0918 4.64083 23.0252 4.69449 22.9853 4.74814C22.972 4.76155 20.776 7.14903 19.4185 8.61103C19.0459 9.01341 18.3805 8.74516 18.3805 8.19523V0.536513C18.3805 0.147541 18.061 0 17.8082 0L15.5723 0C15.1863 0 15 0.254844 15 0.482861V17.4635C15 17.8525 15.3194 17.9598 15.5856 17.9598H17.8215C18.1675 17.9598 18.3938 17.7049 18.3938 17.4501V17.2757V13.5469H18.4071Z"
              fill="white"
            />
            <path
              d="M36.9952 17.3185L36.7582 15.0735C36.7318 14.7661 36.442 14.5523 36.1391 14.6058C35.9679 14.6325 35.7966 14.6459 35.6254 14.6459C33.8604 14.6459 32.4247 13.2428 32.3193 11.4655C32.3193 11.412 32.3193 11.3452 32.3193 11.2784V8.52561C32.3193 8.16481 32.5827 7.87082 32.9384 7.87082H35.902C36.1127 7.87082 36.4289 7.68374 36.4289 7.29621V5.17149C36.4289 4.75724 36.1654 4.54343 35.9283 4.54343H32.9384C32.5959 4.54343 32.3193 4.28953 32.3061 3.94209V0.534521C32.3061 0.320713 32.148 0 31.7397 0L29.54 0C29.2634 0 29 0.173719 29 0.521158C29 0.521158 29 11.412 29 11.4655C29.0922 15.1002 32.0295 18 35.6254 18C35.9283 18 36.2181 17.9733 36.5079 17.9332C36.824 17.8931 37.0348 17.6258 36.9952 17.3185Z"
              fill="white"
            />
            <path
              d="M52.6133 14.6653C50.72 14.6653 50.4267 14.0063 50.4267 11.5383C50.4267 11.5254 50.4267 11.5254 50.4267 11.5124V5.58147C50.4267 5.37472 50.2667 5.02584 49.84 5.02584H47.6C47.32 5.02584 47.0133 5.24551 47.0133 5.58147V5.85282C46.04 5.31012 44.9067 5 43.7067 5C40 5 37 7.90734 37 11.4995C37 15.0917 40 17.9991 43.7067 17.9991C45.3733 17.9991 46.8933 17.4047 48.0667 16.4355C48.6933 17.3659 49.7067 17.9861 51.2933 17.9991C51.56 17.9991 53 18.0507 53 17.3917V15.0788C53 14.885 52.84 14.6653 52.6133 14.6653ZM43.72 14.7687C41.8667 14.7687 40.36 13.3085 40.36 11.5124C40.36 9.71635 41.8667 8.25622 43.72 8.25622C45.5733 8.25622 47.08 9.71635 47.08 11.5124C47.0667 13.3085 45.56 14.7687 43.72 14.7687Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_20797_30696">
              <rect width="53" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      image: "img-team-journey-workday-employer-brand-rectangle-1440_3.webp",
      personImage: "freeman_img_1443.webp",
    },
    alt: "Okta Logo",
    testimonialDescription:
      "“Through a number of page redesign tests we've seen <strong>test lifts between 40-90%.</strong>”",
    personName: "Rodolfo Yiu",
    personDesignation: "Sr. Manager of Digital Marketing",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-01_1.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-01_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "rodolfo-yiu-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Okta Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "6 min",
    videoID: "xv3XXP_Tosg",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  },
  {
    id: "unbounce",
    order: 2,
    logo: "logos.svg",
    sourceFolder: `spiralyze2024website`,
    cloudinaryPath: `https://res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/`,
    blueLogo: {
      fallBackImage: "unbounce.png",
      responsiveImages: [
        {
          imageName: "unbounce.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "unbounce.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "unbounce.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Unbounce Logo",
    testimonialDescription:
      "“It's resulted in a decisive improvement in our website conversion rate … our website looks better, it's easier to use, and it's driving results”",
    personName: "Alex Nazarevich",
    personDesignation: "VP of Growth",
    ctaURL: "",
    ctaText: "See The Unbounce's Case Study",
    videoPlaceholder: {
      fallBackImage: "photo_1.webp",
      responsiveImages: [
        {
          imageName: "photo_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "bill-carney-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Unbounce Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "XZ3rFsNlgzw",
    bgPattern:
      "https://res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/yellow.webp",
  },
  {
    id: "swyftfilings",
    order: 3,
    logo: "logos_webp_2.webp",
    sourceFolder: `spiralyze2024website`,
    cloudinaryPath: `https://res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/`,
    blueLogo: {
      fallBackImage: "swyftfilings.png",
      responsiveImages: [
        {
          imageName: "swyftfilings.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "swyftfilings.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "swyftfilings.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Swyft Filings Logo",
    testimonialDescription:
      "“Spiralyze comes with a very bold value prop … the bold claims actually panned out!”",
    personName: "Ransom Averitt",
    personDesignation: "SVP of Marketing",
    ctaURL: "",
    ctaText: "See The Swyft Filings's Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-17_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-17_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "bill-carney-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Swyft Filings Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "3 min",
    videoID: "U5cxoMhiCMw",
    bgPattern:
      "https://res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/purple.webp",
  },
  {
    id: "record360",
    order: 3,
    logo: "record360new.png",
    blueLogo: {
      fallBackImage: "ideal_image_blue_logo.png",
      responsiveImages: [
        {
          imageName: "ideal_image_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "ideal_image_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "idealimage_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Record360 Logo",
    tSlider: {
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="107"
          height="14"
          viewBox="0 0 107 14"
          fill="none"
        >
          <path
            d="M47.0491 10.8245C49.3529 10.8245 51.2205 8.96575 51.2205 6.67291C51.2205 4.38008 49.3529 2.52136 47.0491 2.52136C44.7453 2.52136 42.8777 4.38008 42.8777 6.67291C42.8777 8.96575 44.7453 10.8245 47.0491 10.8245Z"
            fill="white"
          />
          <path
            d="M46.9628 0.007436C43.5435 0.018684 40.5362 2.97181 40.4566 6.31196C40.2202 9.65161 42.927 12.7806 46.203 13.0991L46.277 12.5378C43.2943 12.1625 40.9785 9.27991 41.2672 6.35798C41.4213 3.42889 44.0978 0.985504 46.9788 1.05657C49.8576 0.988061 52.4756 3.42531 52.5773 6.21789C52.8203 9.01303 50.5054 11.6205 47.7596 11.8649L47.6856 11.3368L46.6043 12.8338L48.038 14L47.9579 13.3875C51.4594 12.98 54.269 9.59128 53.8719 6.1187C53.6356 2.64612 50.3698 -0.163841 46.9628 0.007436ZM90.8582 1.63891C90.7026 1.48246 90.5181 1.35976 90.3127 1.27284C90.1092 1.18592 89.8863 1.14298 89.6505 1.14298H87.9917C87.7559 1.14298 87.5319 1.18592 87.3295 1.27284C87.125 1.35925 86.9401 1.48246 86.7839 1.63891C86.6262 1.79536 86.5029 1.97738 86.4156 2.18189C86.3293 2.38435 86.2841 2.60676 86.2841 2.84092V3.41508L87.5283 3.48922V2.84041C87.5283 2.71617 87.5766 2.6042 87.666 2.51626C87.7543 2.42781 87.8689 2.37975 87.9922 2.37975H89.6515C89.7758 2.37975 89.8883 2.42679 89.9777 2.51626C90.0681 2.60471 90.1144 2.71719 90.1144 2.84041V4.2592C90.1144 4.38241 90.0681 4.49489 89.9777 4.58488C89.8883 4.67333 89.7748 4.72037 89.6515 4.72037H88.1417V5.95816H89.6515C89.7758 5.95816 89.8883 6.00469 89.9777 6.09467C90.0681 6.18363 90.1144 6.29611 90.1144 6.41933V8.18988C90.1144 8.31309 90.0681 8.42608 89.9777 8.51453C89.8873 8.60503 89.7779 8.65105 89.6515 8.65105H87.9922C87.8689 8.65105 87.7533 8.60299 87.666 8.51505C87.5766 8.4266 87.5283 8.31412 87.5283 8.18988V7.54209L86.2841 7.61623V8.18988C86.2841 8.42353 86.3293 8.64696 86.4156 8.84942C86.5029 9.0524 86.6262 9.23594 86.7849 9.39239C86.9406 9.54833 87.124 9.67206 87.33 9.75949C87.5334 9.84589 87.7564 9.88935 87.9922 9.88935H89.6515C89.8873 9.88935 90.1092 9.84589 90.3137 9.75949C90.5192 9.67206 90.7031 9.54833 90.8587 9.39239C91.0165 9.23543 91.1397 9.05342 91.2271 8.84942C91.3154 8.64696 91.3586 8.42506 91.3586 8.18988V6.80228C91.3586 6.55124 91.3072 6.31299 91.2081 6.09774C91.1079 5.88198 90.9692 5.69792 90.7986 5.5517L90.664 5.43922L90.7986 5.32674C90.9692 5.18 91.1079 4.99645 91.2081 4.78121C91.3072 4.56494 91.3586 4.3272 91.3586 4.07616V2.84041C91.3586 2.60625 91.3154 2.38435 91.2271 2.18138C91.1392 1.97687 91.0159 1.79434 90.8582 1.63891ZM105.69 8.18988C105.69 8.3136 105.643 8.42608 105.553 8.51453C105.463 8.6035 105.351 8.65105 105.226 8.65105H103.567C103.441 8.65105 103.328 8.6035 103.239 8.51453C103.151 8.4266 103.102 8.3136 103.102 8.18988V2.84041C103.102 2.71617 103.15 2.60471 103.239 2.51626C103.329 2.42679 103.442 2.37975 103.567 2.37975H105.226C105.349 2.37975 105.462 2.42679 105.553 2.51626C105.643 2.60471 105.69 2.7177 105.69 2.84041V8.18988ZM106.803 2.18189C106.714 1.97738 106.591 1.79434 106.433 1.63891C106.276 1.48246 106.094 1.35925 105.888 1.27284C105.684 1.18592 105.462 1.14298 105.226 1.14298H103.567C103.33 1.14298 103.107 1.18592 102.904 1.27284C102.7 1.35925 102.515 1.48246 102.359 1.63891C102.203 1.79536 102.078 1.97738 101.992 2.18189C101.905 2.38435 101.86 2.60625 101.86 2.84092V8.18988C101.86 8.42557 101.905 8.64798 101.992 8.84891C102.078 9.0524 102.202 9.23543 102.359 9.39188C102.516 9.54833 102.699 9.67155 102.904 9.75847C103.108 9.84538 103.332 9.88833 103.567 9.88833H105.226C105.461 9.88833 105.685 9.84538 105.888 9.75847C106.092 9.67155 106.277 9.54782 106.433 9.39188C106.591 9.23594 106.714 9.05444 106.802 8.84891C106.889 8.64593 106.933 8.42404 106.933 8.18988V2.84041C106.933 2.60727 106.889 2.38537 106.803 2.18189ZM97.5587 5.99242C97.682 5.99242 97.7945 6.03894 97.8859 6.12842C97.9753 6.21789 98.0226 6.33088 98.0226 6.45256V8.18988C98.0226 8.31309 97.9753 8.42608 97.8859 8.51453C97.7945 8.60503 97.684 8.65105 97.5587 8.65105H95.8999C95.7745 8.65105 95.661 8.60299 95.5737 8.51505C95.4833 8.4266 95.436 8.31412 95.436 8.18988V5.99293L97.5587 5.99242ZM98.767 1.63891C98.6093 1.48246 98.4269 1.35925 98.2214 1.27284C98.0185 1.18592 97.795 1.14298 97.5592 1.14298H95.9004C95.6656 1.14298 95.4406 1.18592 95.2382 1.27284C95.0338 1.35925 94.8488 1.48246 94.6926 1.63891C94.5349 1.79587 94.4127 1.9784 94.3253 2.18189C94.238 2.38435 94.1938 2.60625 94.1938 2.84092V8.18988C94.1938 8.42557 94.238 8.64798 94.3253 8.84891C94.4127 9.0524 94.5349 9.23543 94.6926 9.39188C94.8493 9.54884 95.0338 9.67155 95.2382 9.75847C95.4416 9.84538 95.6656 9.88833 95.9004 9.88833H97.5592C97.795 9.88833 98.018 9.84538 98.2214 9.75847C98.4258 9.67155 98.6118 9.54782 98.767 9.39188C98.9236 9.23492 99.0469 9.0524 99.1353 8.84891C99.2216 8.64644 99.2658 8.42455 99.2658 8.18988V6.45205C99.2658 6.21789 99.2216 5.996 99.1353 5.79302C99.048 5.58902 98.9236 5.40598 98.767 5.25005C98.6113 5.09411 98.4269 4.9714 98.2214 4.88346C98.0169 4.79757 97.794 4.7536 97.5592 4.7536H95.437V2.84041C95.437 2.71617 95.4853 2.60471 95.5747 2.51626C95.6631 2.42781 95.7766 2.37975 95.9009 2.37975H97.5597C97.684 2.37975 97.7976 2.42679 97.888 2.51626C97.9753 2.6042 98.0246 2.71668 98.0246 2.84041V3.48819L99.2678 3.41355V2.84041C99.2678 2.60625 99.2237 2.38435 99.1374 2.18138C99.048 1.97687 98.9231 1.79536 98.767 1.63891ZM6.56381 6.68673H1.85505C1.76926 6.68673 1.69477 6.65503 1.63415 6.59316C1.5725 6.53232 1.54116 6.45921 1.54116 6.37434V2.68089C1.54116 2.595 1.5725 2.5224 1.63466 2.46053C1.69528 2.39918 1.76926 2.3685 1.85505 2.3685H6.56381C6.86485 2.3685 7.14586 2.42372 7.40786 2.53416C7.66883 2.64561 7.9 2.80053 8.10035 2.99942C8.30122 3.19881 8.45585 3.42889 8.56784 3.68913C8.67829 3.94936 8.73377 4.22852 8.73377 4.52762C8.73377 4.82569 8.67829 5.10587 8.56681 5.36662C8.45533 5.62634 8.29968 5.85591 8.10035 6.05582C7.9 6.25572 7.66883 6.41013 7.40734 6.52108C7.14534 6.631 6.86485 6.68571 6.56381 6.68673ZM8.00531 7.93526C8.45276 7.74558 8.84782 7.48074 9.19047 7.14023C9.53312 6.79921 9.79923 6.40553 9.98982 5.96123C10.1794 5.51693 10.2744 5.03838 10.2744 4.52659C10.2744 4.01481 10.1784 3.53625 9.9893 3.09196C9.7982 2.64664 9.53209 2.25398 9.18944 1.91245C8.8473 1.57194 8.45122 1.30658 8.0048 1.1169C7.55735 0.928242 7.07702 0.833145 6.5633 0.833145H0L0 12.5245H1.54116V8.18988C1.58843 8.20061 1.63826 8.20675 1.69066 8.21084C1.74306 8.21697 1.79751 8.21851 1.85505 8.21851H4.96049L8.59661 12.5245H10.4234V12.3102L6.95578 8.19908C7.32412 8.1638 7.67448 8.07586 8.00531 7.93526ZM64.1216 6.68673H59.4129C59.3255 6.68673 59.2526 6.65503 59.1899 6.59316C59.1277 6.53181 59.0964 6.45819 59.0964 6.37332V2.68089C59.0964 2.595 59.1277 2.5224 59.1899 2.46053C59.2521 2.39918 59.3255 2.36799 59.4129 2.36799H64.1216C64.4227 2.36799 64.7026 2.42321 64.9646 2.53364C65.2266 2.6451 65.4573 2.80002 65.6571 2.9989C65.858 3.1983 66.0131 3.42837 66.1246 3.68861C66.2361 3.94885 66.2911 4.22801 66.2911 4.52762C66.2911 4.8262 66.2361 5.10638 66.1246 5.36713C66.0131 5.62686 65.857 5.85693 65.6571 6.05633C65.4573 6.25624 65.2266 6.41064 64.9646 6.52108C64.7026 6.631 64.4227 6.68571 64.1216 6.68673ZM65.5636 7.93526C66.0101 7.74558 66.4056 7.48074 66.7488 7.14023C67.0909 6.79921 67.357 6.40553 67.5476 5.96123C67.7372 5.51591 67.8327 5.03787 67.8327 4.52608C67.8327 4.01481 67.7372 3.53625 67.5476 3.09196C67.357 2.64664 67.0909 2.25347 66.7488 1.91193C66.4056 1.57091 66.0101 1.30607 65.5636 1.11639C65.1162 0.92773 64.6353 0.832633 64.1216 0.832633H57.5568V12.5229H59.0979V8.18885C59.1462 8.19908 59.195 8.20521 59.2485 8.21033C59.3019 8.21544 59.3558 8.218 59.4129 8.218H62.5183L66.1534 12.5229H67.9797V12.3102L64.5131 8.19806C64.8814 8.1638 65.2318 8.07586 65.5636 7.93526ZM80.4292 8.83204C80.4292 9.13164 80.3742 9.41029 80.2627 9.67206C80.1502 9.93179 79.9951 10.1614 79.7963 10.3613C79.5954 10.5617 79.3627 10.7156 79.1038 10.8265C78.8397 10.9364 78.5597 10.9922 78.2587 10.9922H73.551C73.4657 10.9922 73.3907 10.9605 73.329 10.8991C73.2669 10.8378 73.2355 10.7626 73.2355 10.6793V2.66709C73.2355 2.5817 73.2669 2.50808 73.329 2.44622C73.3917 2.38537 73.4662 2.35316 73.5515 2.35316H78.2603C78.5613 2.35316 78.8413 2.40889 79.1043 2.51984C79.3653 2.63079 79.5959 2.7857 79.7968 2.98459C79.9977 3.18347 80.1518 3.41355 80.2633 3.67379C80.3747 3.93403 80.4297 4.21369 80.4297 4.51381L80.4292 8.83204ZM80.8869 1.90017C80.5437 1.55915 80.1482 1.2938 79.7018 1.10463C79.2543 0.914949 78.7724 0.819851 78.2587 0.819851H71.6949V12.525H78.2587C78.7724 12.525 79.2543 12.4294 79.7018 12.2407C80.1482 12.052 80.5437 11.7857 80.8869 11.4446C81.229 11.1041 81.4951 10.7099 81.6857 10.2651C81.8753 9.82033 81.9709 9.34127 81.9709 8.82999V4.5133C81.9709 4.00151 81.8753 3.52296 81.6857 3.07815C81.4951 2.63334 81.229 2.24119 80.8869 1.90017ZM28.5629 3.68913C28.6749 3.42889 28.8305 3.19932 29.0299 2.99942C29.2302 2.80002 29.4609 2.64561 29.7229 2.53416C29.9844 2.42372 30.2654 2.3685 30.5659 2.3685H33.3379C33.6374 2.3685 33.9189 2.42372 34.1804 2.53416C34.4419 2.64561 34.6726 2.80053 34.8729 2.99942C35.0733 3.1983 35.2289 3.42889 35.3404 3.68913C35.4514 3.94936 35.5069 4.22852 35.5069 4.52813H37.048C37.048 4.01685 36.9519 3.53779 36.7629 3.09349C36.5713 2.64817 36.3047 2.25551 35.9625 1.91398C35.6199 1.57296 35.2243 1.30812 34.7779 1.11844C34.3309 0.929775 33.8501 0.834678 33.3364 0.834678H30.5649C30.0511 0.834678 29.5708 0.930287 29.1234 1.11844C28.6754 1.30812 28.2809 1.57398 27.9382 1.91398C27.5966 2.25551 27.33 2.64817 27.1399 3.09349C26.9498 3.53779 26.8537 4.01634 26.8537 4.52813V8.83306C26.8537 9.34485 26.9498 9.82289 27.1399 10.2672C27.33 10.713 27.5966 11.1062 27.9392 11.4472C28.2819 11.7887 28.6774 12.0541 29.1239 12.2438C29.5713 12.4324 30.0522 12.528 30.5659 12.528H33.3379C33.8511 12.528 34.332 12.4324 34.7794 12.2438C35.2258 12.0541 35.6214 11.7887 35.9635 11.4472C36.3062 11.1062 36.5728 10.713 36.7634 10.2672C36.953 9.82289 37.0485 9.34485 37.0485 8.83306H35.5074C35.5074 9.13164 35.4519 9.41131 35.3409 9.67206C35.2294 9.93179 35.0733 10.1614 34.8729 10.3618C34.6726 10.5617 34.4424 10.7156 34.1809 10.8275C33.9189 10.938 33.6379 10.9927 33.3384 10.9927H30.5664C30.2659 10.9927 29.9854 10.938 29.7234 10.8275C29.4624 10.7156 29.2307 10.5612 29.0304 10.3618C28.83 10.1634 28.6754 9.93179 28.5634 9.67206C28.4524 9.41131 28.397 9.13164 28.397 8.83306V4.52659C28.3959 4.22801 28.4519 3.94936 28.5629 3.68913ZM14.1381 12.5255H23.5562V10.9922H15.6793V7.44035H22.0155V5.90703H15.6793V2.35316H23.5567V0.81934H14.1381V12.5255Z"
            fill="white"
          />
        </svg>
      ),
      image: "record360_img_1440.webp",
      personImage: "cadi_cadlecek_img_1440.webp",
    },
    testimonialDescription:
      "“Working with Spiralyze has been incredible! The entire team is really knowledgeable. We've seen an increase in paid traffic and the quality of leads has improved. If things continue how they are - it's gonna have an amazing impact on our business.”",
    personName: "Emilia Pintos",

    personDesignation: "Director of Marketing",
    ctaURL: "",
    ctaText: "See Record360 Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-02_1.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-02_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "brian-stetter-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Record360 Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "y4Onk1uFll0",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/yellow.webp",
  },
  {
    id: "workday",
    order: 4,
    logo: "workdaynew.png",
    blueLogo: {
      fallBackImage: "workday_blue_logo.png",
      responsiveImages: [
        {
          imageName: "workday_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "workday_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "workday_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    tSlider: {
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="59"
          height="24"
          viewBox="0 0 59 24"
          fill="none"
        >
          <path
            d="M30.6432 0.0103108C32.7851 -0.0635028 34.9411 0.259036 36.9613 0.976725C40.0006 2.04484 42.7169 4.00225 44.7044 6.53776C45.5787 7.65012 46.311 8.87281 46.885 10.1664C46.9867 10.3817 47.0651 10.6237 47.0106 10.8635C46.9439 11.2661 46.5914 11.599 46.1859 11.6392C45.7647 11.7009 45.3295 11.4378 45.1794 11.0406C44.0381 8.35186 42.0903 6.01638 39.6606 4.39974C38.1586 3.39489 36.474 2.66317 34.7142 2.2535C32.4447 1.72206 30.0552 1.72206 27.7853 2.25188C24.5442 2.99908 21.5766 4.86025 19.4836 7.44636C18.5961 8.536 17.8634 9.75066 17.311 11.0429C17.1914 11.3432 16.9167 11.5786 16.5962 11.6313C16.2872 11.691 15.9507 11.5842 15.7352 11.3538C15.4812 11.0989 15.3981 10.6916 15.5291 10.3571C17.0494 6.75866 19.8645 3.73571 23.3255 1.93636C25.5797 0.755164 28.1014 0.0962972 30.6432 0.0103108Z"
            fill="white"
          />
          <path
            d="M27.8127 11.0895C27.7998 10.9026 27.9765 10.7628 28.1515 10.7583C28.3789 10.7522 28.607 10.7541 28.8349 10.7574C28.9933 10.7628 29.1781 10.8684 29.1775 11.0465C29.1856 13.1375 29.1726 15.2292 29.1845 17.3214C30.0308 16.3793 30.8843 15.4424 31.7336 14.5031C31.9009 14.3379 32.0331 14.0878 32.2933 14.0662C32.6438 14.0517 32.9952 14.0604 33.3461 14.0608C33.4814 14.0487 33.6323 14.1728 33.5848 14.3173C33.5294 14.4288 33.4276 14.5054 33.3445 14.594C32.4262 15.5126 31.5043 16.4281 30.5906 17.3507C31.4732 18.3593 32.3436 19.3783 33.2221 20.3906C33.3352 20.5347 33.4767 20.657 33.5715 20.8158C33.6409 20.9399 33.5258 21.091 33.3929 21.0969C33.1012 21.1133 32.8087 21.0969 32.5163 21.1039C32.3642 21.1004 32.1997 21.1226 32.0616 21.0442C31.9161 20.9605 31.8277 20.8111 31.7235 20.6853C30.8761 19.6169 30.0342 18.5444 29.1838 17.4779C29.1751 18.5296 29.1812 19.5809 29.1805 20.6319C29.1772 20.7532 29.202 20.8994 29.0965 20.9879C28.9285 21.1503 28.6784 21.0933 28.4688 21.1039C28.2827 21.0976 28.0651 21.1383 27.914 21.0008C27.8298 20.9352 27.8077 20.8233 27.811 20.7237C27.8134 17.5119 27.8101 14.3005 27.8127 11.0895Z"
            fill="white"
          />
          <path
            d="M23.9526 14.0433C24.3775 13.9065 24.8564 13.8805 25.2727 14.0609C25.4187 14.1295 25.5883 14.2759 25.5223 14.4563C25.4556 14.6828 25.3988 14.9118 25.3193 15.1344C25.2605 15.2941 25.0754 15.3534 24.9196 15.3222C24.5691 15.262 24.2249 15.1461 23.8656 15.1578C23.6148 15.1519 23.3833 15.2866 23.2118 15.4612C22.9351 15.7322 22.7918 16.1111 22.7275 16.4871C22.6765 16.7588 22.691 17.0364 22.6887 17.3109C22.6887 18.4645 22.6891 19.6189 22.6885 20.7725C22.7048 20.9622 22.5088 21.091 22.3377 21.0976C22.1028 21.1009 21.8683 21.1039 21.6337 21.0957C21.464 21.0868 21.2732 20.9629 21.2951 20.7718C21.2942 18.6355 21.2928 16.5 21.2956 14.3638C21.2811 14.1513 21.5162 14.0358 21.7006 14.0557C21.932 14.0709 22.2479 13.9838 22.3983 14.2169C22.5125 14.4872 22.5667 14.7791 22.674 15.0517C22.9966 14.6085 23.4243 14.2178 23.9526 14.0433Z"
            fill="white"
          />
          <path
            d="M0 14.2063C0.0652783 14.1314 0.141554 14.0503 0.250352 14.0581C0.569023 14.055 0.888628 14.048 1.20707 14.0627C1.36875 14.0674 1.48011 14.2096 1.50375 14.3602C1.81703 15.6357 2.12471 16.913 2.4366 18.1888C2.52808 18.5828 2.63945 18.9728 2.69912 19.3736C2.76065 19.7336 2.77282 20.099 2.83131 20.4598C2.9118 19.9449 2.98386 19.4268 3.12261 18.9239C3.53042 17.4011 3.938 15.8786 4.34629 14.3563C4.37811 14.1827 4.54119 14.0592 4.71456 14.0592C5.06926 14.0503 5.42467 14.0564 5.77937 14.0564C5.9696 14.0475 6.17318 14.1588 6.219 14.3539C6.52364 15.464 6.82456 16.5761 7.128 17.6871C7.31212 18.4067 7.55333 19.1141 7.65749 19.8524C7.68624 20.0557 7.71433 20.2595 7.7562 20.4614C7.87061 19.3015 8.16871 18.1729 8.41393 17.0371C8.61633 16.1334 8.81423 15.2288 9.01895 14.3251C9.04914 14.1436 9.24099 14.0522 9.40996 14.0573C9.69681 14.0557 9.98414 14.0475 10.2705 14.0621C10.4406 14.067 10.5384 14.2553 10.4785 14.4071C9.90292 16.5333 9.32946 18.6608 8.75367 20.787C8.72276 20.9575 8.5744 21.0906 8.40058 21.0934C7.95602 21.1079 7.51056 21.0969 7.06601 21.0992C6.90668 21.1091 6.73819 21.0236 6.7101 20.8556C6.31214 19.3935 5.9221 17.9288 5.52785 16.4656C5.38513 15.9565 5.32734 15.4288 5.26744 14.9053C5.19421 15.3715 5.15794 15.8453 5.03394 16.3033C4.63033 17.8099 4.22438 19.3172 3.81984 20.824C3.77422 21.0681 3.49556 21.1168 3.28826 21.1009C2.87483 21.0934 2.4614 21.1105 2.04843 21.0934C1.90127 21.0939 1.78779 20.9791 1.76135 20.8399C1.1811 18.7222 0.602715 16.6035 0.0219935 14.4863C0.00187179 14.3937 0.00444549 14.2993 0 14.2063Z"
            fill="white"
          />
          <path
            d="M52.1356 14.0619C52.4374 14.0568 52.7404 14.0556 53.0423 14.0619C53.2259 14.0645 53.3986 14.1903 53.4564 14.3659C53.9777 15.7297 54.4952 17.096 55.0158 18.4604C55.1246 18.7373 55.2006 19.0261 55.2493 19.3194C55.4646 18.5101 55.7512 17.7225 56.0027 16.9238C56.2828 16.0602 56.5631 15.1963 56.8443 14.3324C56.886 14.1821 57.0291 14.0795 57.1812 14.0668C57.4276 14.0486 57.6756 14.0645 57.9224 14.0579C58.0668 14.0596 58.2388 14.0427 58.3488 14.1587C58.4201 14.2191 58.4049 14.3195 58.3752 14.398C57.5423 16.7767 56.7117 19.1566 55.8799 21.5359C55.7353 21.9323 55.6241 22.3471 55.3914 22.7036C55.0574 23.2466 54.5163 23.6375 53.9215 23.849C53.7138 23.9135 53.4992 24.0563 53.2757 23.9762C53.1171 23.9357 53.0563 23.7706 52.9716 23.6492C52.9108 23.5392 52.7985 23.4373 52.8218 23.3002C52.8329 23.1644 52.9416 23.0538 53.0699 23.0175C53.3207 22.9308 53.5757 22.8353 53.7788 22.658C54.2725 22.2398 54.5778 21.6215 54.6941 20.9921C54.6153 20.7126 54.4695 20.4557 54.3637 20.1851C53.5694 18.337 52.7751 16.4882 51.9788 14.6407C51.9309 14.5198 51.8602 14.4046 51.8466 14.2734C51.8485 14.1294 52.0135 14.0661 52.1356 14.0619Z"
            fill="white"
          />
          <path
            d="M15.1006 14.9559C14.6673 15.0365 14.2721 15.3066 14.0522 15.6912C13.6846 16.3149 13.6423 17.0676 13.6589 17.775C13.6851 18.4153 13.7878 19.0984 14.1959 19.616C14.5003 20.0053 15.0005 20.2009 15.4867 20.1934C15.9544 20.2084 16.4443 20.0499 16.7614 19.6938C17.1663 19.2504 17.2964 18.6351 17.3522 18.0549C17.3767 17.485 17.3882 16.9048 17.2406 16.3482C17.1231 15.8781 16.8751 15.408 16.446 15.1547C16.0466 14.9095 15.5531 14.8866 15.1006 14.9559ZM15.2836 13.9417C16.0677 13.8934 16.8891 14.0564 17.5363 14.5214C18.1151 14.9336 18.5082 15.5689 18.6919 16.2501C18.9102 17.0633 18.9092 17.9312 18.7113 18.7487C18.5248 19.5022 18.0887 20.2126 17.4308 20.6408C16.7277 21.1079 15.8444 21.2292 15.0192 21.1297C14.3161 21.043 13.631 20.7343 13.1416 20.2157C12.5662 19.6123 12.2805 18.781 12.2211 17.9593C12.1488 17.0481 12.2883 16.0835 12.7946 15.3054C13.1692 14.7198 13.7647 14.2895 14.4289 14.0932C14.7059 14.0065 14.9949 13.9662 15.2836 13.9417Z"
            fill="white"
          />
          <path
            d="M38.4102 14.9189C37.9804 14.9465 37.5656 15.1941 37.3737 15.5869C36.9989 16.3133 36.9912 17.1586 37.0099 17.9574C37.0398 18.4793 37.0965 19.018 37.3393 19.4893C37.5036 19.8067 37.8019 20.0573 38.1547 20.1342C38.6945 20.2642 39.3298 20.1541 39.7135 19.7271C40.0832 19.3057 40.2048 18.7327 40.2617 18.1905C40.3007 17.5723 40.3031 16.9415 40.1498 16.3365C40.0445 15.9319 39.8663 15.5279 39.5462 15.2468C39.2392 14.9763 38.8115 14.872 38.4102 14.9189ZM40.2598 11.0001C40.25 10.8361 40.4173 10.7314 40.5628 10.7188C40.7956 10.7061 41.0291 10.7122 41.2624 10.7148C41.4402 10.7131 41.6391 10.8455 41.6134 11.0432C41.6134 14.2696 41.614 17.4955 41.6129 20.7214C41.625 20.888 41.4612 21.0172 41.3075 21.0273C41.122 21.0372 40.936 21.0372 40.7511 21.0243C40.6208 21.0161 40.4945 20.9324 40.45 20.8076C40.3803 20.598 40.344 20.3801 40.2909 20.167C40.0336 20.5164 39.7017 20.8256 39.2895 20.9791C38.7015 21.1957 38.0471 21.1993 37.4428 21.0517C36.8356 20.9055 36.3068 20.4879 36.0139 19.9381C35.5541 19.0988 35.4996 18.1115 35.5284 17.1753C35.5448 16.3754 35.6973 15.5314 36.2179 14.8966C36.6105 14.3586 37.2539 14.0498 37.9037 13.9691C38.5085 13.8805 39.1643 13.9824 39.665 14.3492C39.9018 14.516 40.0913 14.7397 40.2605 14.9735C40.2558 13.6493 40.257 12.3247 40.2598 11.0001Z"
            fill="white"
          />
          <path
            d="M46.7673 14.9592C46.5517 15.0032 46.3427 15.0899 46.1684 15.225C45.8198 15.4967 45.6466 15.9285 45.5542 16.3477C45.4197 17.013 45.4215 17.7 45.4911 18.3727C45.5561 18.867 45.6801 19.3945 46.0421 19.7599C46.3369 20.0698 46.7814 20.1834 47.1974 20.163C47.6448 20.1792 48.1104 20.0124 48.3989 19.6606C48.7596 19.2237 48.8614 18.6426 48.9141 18.0951C48.9475 17.4515 48.948 16.7923 48.7674 16.1674C48.6532 15.7781 48.4445 15.3909 48.0923 15.1691C47.7044 14.9142 47.2138 14.8908 46.7673 14.9592ZM46.1684 14.0756C46.7892 13.9035 47.4536 13.8934 48.0807 14.037C48.6633 14.1722 49.2089 14.4996 49.5669 14.9844C49.9454 15.4815 50.1366 16.0978 50.2161 16.712C50.2852 17.1856 50.2653 17.6653 50.2659 18.1425C50.2659 19.0035 50.2659 19.8648 50.2636 20.7256C50.273 20.8306 50.2068 20.9236 50.1213 20.9781C49.977 21.0671 49.798 21.0278 49.637 21.0379C49.4564 21.0365 49.2189 21.0524 49.1206 20.8643C49.0248 20.6432 49.0049 20.3965 48.9433 20.1639C48.7011 20.4586 48.4503 20.7626 48.0998 20.9329C47.5659 21.1972 46.9417 21.1817 46.3703 21.07C45.6712 20.9318 45.0273 20.5179 44.6319 19.9215C44.1609 19.227 43.9901 18.3697 43.9966 17.5412C43.9908 16.7335 44.1487 15.8985 44.5973 15.2152C44.9559 14.6566 45.5315 14.252 46.1684 14.0756Z"
            fill="white"
          />
        </svg>
      ),
      image: "img-team-journey-workday-employer-brand-rectangle-1440.webp",
      personImage: "freeman_img_1440.webp",
    },
    alt: "Workday Logo",
    testimonialDescription:
      "“Working with Spiralyze, for Adaptive Insights, has been fantastic. They have truly been an <strong>extension of our team,</strong> they have helped us improve our conversion rates, we have driven more leads, we have beaten plan, and we have helped build a lot of pipeline.”",
    personName: "Michael Freeman",
    personDesignation: "VP of Demand Marketing",
    ctaURL: "",
    ctaText: "See Workday Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-04_1.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-04_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "michael-freeman-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Workday Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "2uQsuv_1tX0",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/red.webp",
  },
  {
    id: "podium",
    order: 5,
    logo: "podiumnew.png",
    blueLogo: {
      fallBackImage: "podium_blue_logo.png",
      responsiveImages: [
        {
          imageName: "podium_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "podium_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "podium_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    tSlider: {
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="93"
          height="20"
          viewBox="0 0 93 20"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 11.6176L5.70007 20L12.2183 20L9.12823 11.6176L16.4854 11.6176L16.4854 0L0 0L0 11.6176ZM55.0372 7.90232C54.2792 7.06223 53.1487 6.8459 52.0738 6.96416C49.0668 7.29498 47.68 9.61222 47.68 12.1075C47.68 14.5462 48.993 17.0221 52.0738 17.3172C53.1854 17.4237 54.2734 17.0712 55.0372 16.2199V17.0588H57.98V2.64706L55.0372 2.64706V7.90232ZM24.7255 17.0588H27.9627V12.6471H29.6822C30.6113 12.6471 35.3134 12.3763 35.3134 7.79412C35.3134 3.21191 30.6113 2.89441 29.6822 2.89441L24.7255 2.89441L24.7255 17.0588ZM32.0827 7.79412C32.0827 9.70588 30.0227 9.70588 29.3002 9.70588H27.9627V5.88235H29.3417C30.0227 5.88235 32.0827 5.88235 32.0827 7.79412ZM35.9084 12.1075C35.9085 15 38.2394 17.3397 41.0585 17.3529C43.891 17.3662 46.2085 14.9549 46.2085 12.1075C46.2085 9.11765 43.8542 6.76471 41.0585 6.76471C38.2628 6.76471 35.9084 9.11765 35.9084 12.1075ZM43.2657 12.1075C43.2657 13.5294 42.3828 14.4074 41.0585 14.4074C39.7342 14.4074 38.8513 13.2353 38.8513 12.1075C38.8513 10.8753 39.7342 9.70588 41.0585 9.70588C42.3828 9.70588 43.2657 10.8824 43.2657 12.1075ZM55.0372 12.1075C55.0372 13.5294 54.1543 14.4074 52.83 14.4074C51.512 14.4135 50.6495 13.332 50.6229 12.1075C50.5956 10.8559 51.5057 9.70588 52.83 9.70588C54.1543 9.70588 55.0372 10.5882 55.0372 12.1075Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M60.3334 7.05844L63.2763 7.05844V17.0584H60.3334V7.05844Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M72.1057 7.05844L75.0486 7.05844V17.0584H72.1057V7.05844Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M77.4028 7.05844L80.3457 7.05844V17.0584H77.4028V7.05844Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M65.6305 7.05844L68.5734 7.05844V12.9408C68.5734 13.2349 68.7206 14.7055 70.3391 14.7055C71.9577 14.7055 72.1049 12.3526 72.1049 12.3526V15.7349C72.1049 15.7349 71.222 17.3526 69.3091 17.3526C66.5134 17.3526 65.6305 14.5584 65.6305 12.9408V7.05844Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M86.8206 17.3526H83.8777V11.4702C83.8777 11.1761 83.7306 9.70553 82.112 9.70553C80.4934 9.70553 80.3463 12.0585 80.3463 12.0585V8.67612C80.3463 8.67612 81.2291 7.05847 83.142 7.05847C85.9377 7.05847 86.8206 9.85259 86.8206 11.4702V17.3526Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M93 17.3526L90.0571 17.3526V11.4702C90.0571 11.1761 89.91 9.70553 88.2914 9.70553C86.6728 9.70553 86.5257 12.0585 86.5257 12.0585L86.0842 8.97024C86.0842 8.97024 87.4085 7.05847 89.3214 7.05847C92.1171 7.05847 93 9.85259 93 11.4702V17.3526Z"
            fill="white"
            fillOpacity="0.8"
          />
          <path
            d="M60.3334 2.64702L63.2763 2.64702V5.29408L60.3334 5.29408V2.64702Z"
            fill="white"
            fillOpacity="0.8"
          />
        </svg>
      ),
      image: "podium_office_1440.webp",
      personImage: "matt_boyce_img_1440.webp",
    },
    alt: "Podium Logo",
    testimonialDescription:
      "“If we even improve conversion on our page by 1% or 2%, it would pay for the Spiralyze contract. Most of the tests we've run have <strong>improved conversion rates by 20-50% </strong> and they have tests mapped out for the rest of the year. It is not even close to what we could've done on our own and is significantly better.”",
    personName: "Matt Boyce",
    personDesignation: "Sr. Director of Demand Generation",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb_1.webp",
      responsiveImages: [
        {
          imageName: "review-thumb_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "matt-boyce-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Podium Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "5 min",
    videoID: "G-55Zm8r57s",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/gray.webp",
  },
  {
    id: "servicefusion",
    order: 6,
    logo: "servicefusion.png",
    blueLogo: {
      fallBackImage: "servicefusion.png",
      responsiveImages: [
        {
          imageName: "servicefusion.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "servicefusion.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "servicefusion.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Service Fusion Logo",
    testimonialDescription:
      "“Astronomical... The value they provide and the speed at which they provide that value is among the best I've ever seen in an agency partner engagement.”",
    personName: "Annie Wight",
    personDesignation: "Marketing Director ",
    ctaURL: "",
    ctaText: "See Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-19.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-19.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "matt-boyce-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Service Fusion Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "3 min",
    videoID: "uu71vCFpLgU",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/purple.webp",
  },
  {
    id: "five9",
    order: 7,
    logo: "fiveninenew.png",
    blueLogo: {
      fallBackImage: "five9_blue_logo.png",
      responsiveImages: [
        {
          imageName: "five9_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "five9_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "five9_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Five9 Logo",
    testimonialDescription:
      "“Spiralyze helps us turn thousands of website visitors into leads for our sales force. They have tremendous experience and great suggestions.”",
    personName: "Jason Yang",
    personDesignation: "VP of Digital Marketing",
    ctaURL: "",
    ctaText: "See THE FIVE9 Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-06_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-06_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "jason-yang-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Five9 Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "YdkdALKm37w",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  },
  {
    id: "progress",
    order: 8,
    logo: "progressnew.png",
    blueLogo: {
      fallBackImage: "progress_blue_logo.png",
      responsiveImages: [
        {
          imageName: "progress_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "progress_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "progress_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    tSlider: {
      folderName: "spiralyze2024website",
      logo: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="83"
          height="20"
          viewBox="0 0 83 20"
          fill="none"
        >
          <path
            d="M16 4.83446V13.3325C15.9944 13.4354 15.9644 13.5354 15.9126 13.6246C15.8608 13.7137 15.7886 13.7895 15.7018 13.8457L15.4221 14.0124L13.2915 15.2371L11.8526 16.0702L11.5544 16.2369V7.04571L3.55612 2.44681L7.35512 0.268979L7.70519 0.0708117C7.79762 0.0242539 7.89976 0 8.00335 0C8.10695 0 8.20909 0.0242539 8.30151 0.0708117L13.5678 3.09679L15.9983 4.49312V4.83469L16 4.83446ZM9.77555 8.06538L8.13568 7.12227L4.29815 4.9178C4.2055 4.872 4.10345 4.84816 3.99999 4.84816C3.89654 4.84816 3.79448 4.872 3.70183 4.9178L0.296488 6.874L0 7.04567L5.77723 10.3632V17L9.17756 15.0454L9.4774 14.8788C9.56407 14.8225 9.63622 14.7467 9.68801 14.6575C9.73981 14.5684 9.7698 14.4684 9.77555 14.3655V8.06538ZM0 13.6824L3.99665 15.9785V11.3829L0 13.6824Z"
            fill="white"
          />
          <path
            d="M24.3773 5H20V16.4405H21.9445V11.9506H24.3975C27.0525 11.9506 28.5139 10.7007 28.5139 8.42986C28.5139 7.39911 28.1098 5.00162 24.3807 5.00162M26.5323 8.46072C26.5323 9.75116 25.8386 10.2771 24.1349 10.2771H21.9462V6.68978H24.3992C25.8403 6.68978 26.539 7.26926 26.539 8.46072M34.2953 8.10522L34.4416 8.17336L34.1049 9.86476L33.8776 9.79663C33.6955 9.74204 33.506 9.7141 33.3153 9.71375C31.4987 9.71375 31.3506 11.1081 31.3506 12.7979V16.4404H29.5592V8.03857H31.2428V9.05147C31.7024 8.36972 32.2529 8.01747 32.9887 7.93142C33.4325 7.87309 33.8843 7.93322 34.2951 8.10519M38.7213 7.87634C37.3037 7.87634 36.1689 8.3958 35.4383 9.38108C34.6706 10.4151 34.5578 11.6293 34.5578 12.2607C34.5578 14.9163 36.1908 16.6304 38.7213 16.6304C41.7955 16.6304 42.8848 14.2426 42.8848 12.199C42.8848 11.0221 42.5228 9.9557 41.8746 9.19441C41.1321 8.33249 40.0445 7.87634 38.7263 7.87634M38.7263 15.0802C37.3172 15.0802 36.4417 13.9992 36.4417 12.2607C36.4417 10.5222 37.3172 9.41194 38.7263 9.41194C40.1355 9.41194 41.0294 10.5108 41.0294 12.2233C41.0294 13.9813 40.1472 15.0737 38.7297 15.0737M58.0151 8.10522L58.1614 8.17336L57.8247 9.86476L57.5974 9.79663C57.4159 9.74206 57.2269 9.71411 57.0368 9.71375C55.2219 9.71375 55.0737 11.1081 55.0737 12.7979V16.4404H53.279V8.03857H54.9626V9.05147C55.4222 8.36972 55.9728 8.01747 56.7085 7.93142C57.1504 7.87339 57.6004 7.9329 58.0099 8.10349M64.4748 13.7458L64.4412 13.8384C64.0658 14.8707 63.1668 15.0882 62.4799 15.0882C61.1179 15.0882 60.2407 14.2166 60.1549 12.8011H66.3151L66.3376 12.6387C66.3596 12.4165 66.3663 12.1931 66.3577 11.97C66.3577 11.9149 66.3577 11.8661 66.3577 11.8189C66.2717 9.46365 64.6809 7.87612 62.4114 7.87612C61.0813 7.87612 59.9921 8.37935 59.258 9.33706C58.6389 10.1934 58.3128 11.215 58.3253 12.2588C58.3253 14.856 60.0005 16.5993 62.4905 16.5993C64.4182 16.5993 65.7449 15.6546 66.2281 13.9405L66.2837 13.7458H64.4822L64.4748 13.7458ZM60.2221 11.2931C60.3737 10.1292 61.2003 9.38908 62.3754 9.38908C63.2728 9.38908 64.3351 9.89226 64.4833 11.2931H60.2221ZM50.0028 8.74302C49.4219 8.16191 48.6458 7.86812 47.6862 7.86812C45.0447 7.86812 43.8426 10.1098 43.8426 12.1908C43.8426 14.3269 45.0312 16.4825 47.6862 16.4825C48.103 16.4899 48.5171 16.4157 48.9034 16.2645C49.2897 16.1133 49.6402 15.8882 49.9338 15.6028C49.9338 15.9729 49.9162 16.3251 49.907 16.4761C49.8092 17.8623 49.119 18.5067 47.7334 18.5067C46.9809 18.5067 46.1155 18.2486 45.9489 17.5328L45.9118 17.3704H44.1373L44.1658 17.5992C44.351 19.0796 45.6996 20 47.6845 20C49.4254 20 50.6645 19.3669 51.2672 18.1723C51.5584 17.596 51.7049 16.7568 51.7049 15.6773V8.03845H49.9995V8.74295L50.0028 8.74302ZM47.7956 14.9356C47.166 14.9356 45.7029 14.6613 45.7029 12.1161C45.7029 10.4442 46.5228 9.4053 47.8428 9.4053C48.863 9.4053 49.9506 10.1179 49.9506 12.1161C49.9506 13.8805 49.1442 14.9356 47.7939 14.9356M74.6756 13.9114C74.6756 15.2473 73.5257 16.5946 70.9566 16.5946C68.6838 16.5946 67.3319 15.645 67.15 13.9243L67.1247 13.7458H68.8958L68.9312 13.8821C69.1484 14.9177 70.172 15.1352 70.9919 15.1352C71.8909 15.1352 72.8438 14.856 72.8438 14.0736C72.8438 13.6775 72.5761 13.3951 72.0475 13.236C71.7343 13.1468 71.3488 13.0413 70.943 12.9325C70.2427 12.7443 69.517 12.5461 69.0709 12.3984C67.9665 12.017 67.3318 11.2736 67.3318 10.3597C67.3318 8.66665 69.0423 7.90698 70.736 7.90698C73.002 7.90698 74.1738 8.72994 74.322 10.4213L74.337 10.5951H72.5962L72.5736 10.4619C72.4052 9.48799 71.3951 9.34189 70.8092 9.34189C70.3042 9.34189 69.1256 9.42791 69.1256 10.2347C69.1256 10.5999 69.4506 10.8693 70.1173 11.056C70.316 11.1096 70.6123 11.1826 70.9591 11.2687C71.6695 11.4455 72.5551 11.6679 73.0012 11.8157C74.1107 12.1923 74.673 12.8983 74.673 13.9259M82.9882 13.9259C82.9882 15.2618 81.8384 16.609 79.2692 16.609C76.9964 16.609 75.6445 15.6594 75.4626 13.9388L75.4451 13.762H77.228L77.248 13.8821C77.4653 14.9177 78.4888 15.1352 79.3087 15.1352C80.2078 15.1352 81.1606 14.856 81.1606 14.0736C81.1606 13.6775 80.893 13.3951 80.366 13.236C80.0529 13.1468 79.6673 13.0413 79.2599 12.9325C78.5595 12.7443 77.8356 12.5461 77.3895 12.3984C76.2833 12.017 75.6503 11.2736 75.6503 10.3597C75.6503 8.66665 77.3608 7.90698 79.0545 7.90698C81.3206 7.90698 82.4924 8.72994 82.6388 10.4213L82.6539 10.5951H80.9147L80.8922 10.4619C80.7238 9.48799 79.7137 9.34189 79.1278 9.34189C78.6227 9.34189 77.4526 9.42791 77.4526 10.2347C77.4526 10.5999 77.7776 10.8693 78.4442 11.056C78.643 11.1096 78.9392 11.1826 79.286 11.2687C79.9965 11.4455 80.8821 11.6679 81.3282 11.8157C82.436 12.1923 83 12.8983 83 13.9259"
            fill="white"
          />
        </svg>
      ),
      image: "image-462_1.webp",
      personImage: "freeman_img_1442.webp",
    },
    alt: "Progress Logo",
    testimonialDescription:
      "“We saw a <strong>125% increase in conversion rate</strong> for demo requests.”",
    personName: "Megan Gouveia",
    personDesignation:
      "Sr. Manager of Digital Marketing, Personalization & Optimization",
    ctaURL: "",
    ctaText: "See Progress Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-07_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-07_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "megan-gouveia-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Progress Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "3 min",
    videoID: "oETkNoINKCQ",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/green.webp",
  },
  {
    id: "timedoctor",
    order: 9,
    logo: "timedoctornew.png",
    blueLogo: {
      fallBackImage: "timedoctor_blue_logo.png",
      responsiveImages: [
        {
          imageName: "timedoctor_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "timedoctor_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "timedoctor_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "TimeDoctor Logo",
    testimonialDescription:
      "“Now 50% more is actually converting and getting revenue for us so it’s absolutely huge.”",
    personName: "Rob Rawson",
    personDesignation: "CEO",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-08_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-08_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "rob-rawson-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "TimeDoctor Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "1 min",
    videoID: "WridNRgdLS8",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/red.webp",
  },
  {
    id: "servicemax",
    order: 10,
    logo: "servicemaxnew.png",
    blueLogo: {
      fallBackImage: "servicemax_blue_logo.png",
      responsiveImages: [
        {
          imageName: "servicemax_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "servicemax_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "servicemax_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "ServiceMax Logo",
    testimonialDescription:
      "“We had aggressive KPI targets, and I’d have to say they’ve delivered on all points. On our landing pages, we’ve seen over a 30% conversion rate increase. We have a lot of exciting initiatives for the next year and Spiralyze is at the core of a lot of these initiatives.”",
    personName: "Pat Oldenburg",
    personDesignation: "VP of Demand Marketing & Ops",
    ctaURL: "",
    ctaText: "See ServiceMax Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-09_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-09_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "pat-oldenburg-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "ServiceMax Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "4 min",
    videoID: "9LBXrVZsiXA",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/green.webp",
  },
  {
    id: "digitalguardian",
    order: 11,
    logo: "digitalguardiannew.png",
    blueLogo: {
      fallBackImage: "digitalguardian_blue_logo.png",
      responsiveImages: [
        {
          imageName: "digitalguardian_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "digital_guardian_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "digitalguardian_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Digital Guardian Logo",
    testimonialDescription:
      "“For all of 2020, we actually increased our year-over-year website conversion rate by 50%, and we not only increased the conversion volume but the conversion quality.”",
    personName: "Brian Mullins",
    personDesignation: "VP of Digital and Product Marketing",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-10_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-10_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "brian-mullins-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Digital Guardian Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "3 min",
    videoID: "cP3CWxHmGSM",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/purple.webp",
  },
  {
    id: "latka",
    order: 21,
    logo: "latkanew.png",
    blueLogo: {
      fallBackImage: "latka_blue_logo.png",
      responsiveImages: [
        {
          imageName: "latka_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "latka_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "latka_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Nathan Latka Logo",
    testimonialDescription:
      "“The impact that Spiralyze has had has basically been going from $10K-20K per month in sales on the magazine landing page to $30K-50K in sales per month on the landing page. It’s a material difference, and I’m excited to give them more and larger projects in the future.”",
    personName: "Nathan Latka",
    personDesignation: "Founder, Author, & Investor",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-11_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-11_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "nathan-latka-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Nathan Latka Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "6 min",
    videoID: "mrLM14toyXs",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  },
  {
    id: "ubersuggest",
    order: 13,
    logo: "ubersuggestnew.png",
    blueLogo: {
      fallBackImage: "ubersuggest_blue_logo.png",
      responsiveImages: [
        {
          imageName: "ubersuggest_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "ubersuggest_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "ubersuggest_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Ubersuggest Logo",
    testimonialDescription:
      "“Spiralyze has run over 60 tests on Ubersuggest. My revenue has doubled. It has been well worth it!”",
    personName: "Neil Patel",
    personDesignation: "Founder",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-13_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-13_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "neil-patel-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Ubersuggest Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "4 min",
    videoID: "rvRAwbs_s48",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/green.webp",
  },
  {
    id: "rstudio",
    order: 14,
    logo: "rstudionew.png",
    blueLogo: {
      fallBackImage: "rstudio_blue_logo.png",
      responsiveImages: [
        {
          imageName: "rstudio_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "rstudio_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "rstudio_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "RStudio Logo",
    testimonialDescription:
      "“Spiralyze really jumpstarted the whole website testing program and process for us. They increased exponentially our qualified pro-conversions. More importantly, they acted as an extension of our team.”",
    personName: "Bill Carney",
    personDesignation: "Director of Marketing",
    ctaURL: "",
    ctaText: "See The R-STUDIO Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-14_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-14_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "bill-carney-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "RStudio Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "8RnNZpui6vw",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/purple.webp",
  },
  {
    id: "optimoroute",
    order: 15,
    logo: "optimoroute.png",
    blueLogo: {
      fallBackImage: "optimoroute.png",
      responsiveImages: [
        {
          imageName: "optimoroute.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "optimoroute.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "optimoroute.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "OptimoRoute Logo",
    testimonialDescription:
      "“If we're going to do this right, we need to do it with Spiralyze. So far, we’ve seen an increase in conversions and time spent on the page.”",
    personName: "Bart Bartolozzi ",
    personDesignation: "Head of Product Marketing",
    ctaURL: "",
    ctaText: "See The Optimoroute Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-18.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-18.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "bill-carney-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Optimoroute Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "pqKz4HKb2sE",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  },
  {
    id: "promscent",
    logo: "promescentnew.png",
    order: 16,
    blueLogo: {
      fallBackImage: "promscent_blue_logo.png",
      responsiveImages: [
        {
          imageName: "promscent_blue_logo.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "promscent_blue_logo_tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "promscent_blue_logo_mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Promescent Logo",
    testimonialDescription:
      "“They got up 3 tests in a matter of 3 weeks and one of those ended up winning by 30%.”",
    personName: "Ryan Kellner",
    personDesignation: "Director of Marketing",
    ctaURL: "",
    ctaText: "See time doctor Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-12_1.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-12_1.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "ryan-kellner-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Promescent Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "4 min",
    videoID: "zUm4ipoEr90",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/yellow.webp",
  },
  {
    id: "nurturelife",
    order: 17,
    logo: "nurturelifenew.png",
    blueLogo: {
      fallBackImage: "logo-nurture-life-blue.png",
      responsiveImages: [
        {
          imageName: "logo-nurture-life-blue.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "logo-nurture-life-blue-tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "logo-nurture-life-blue-mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Nurture Life Logo",
    testimonialDescription:
      "“Spiralyze has had a really big impact on Nurture Life. When we first started working with them our conversion rate was relatively flat and since the beginning of our engagement, we've seen a steady upward increase.”",
    personName: "Amy Rose Carle",
    personDesignation: "Director of Operations Excellence",
    ctaURL: "",
    ctaText: "",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-15_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-15_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "amy-rose-carle-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Nurture Life Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "_JuuAIc8jyc",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/green.webp",
  },
  {
    id: "caroo",
    order: 18,
    logo: "caroonew.png",
    blueLogo: {
      fallBackImage: "logo-caroo-blue.png",
      responsiveImages: [
        {
          imageName: "logo-caroo-blue.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "logo-caroo-blue-tablet.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "logo-caroo-blue-mobile.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Caroo Logo",
    testimonialDescription:
      "“Spiralyze professionalized our CRO testing process which gave us a higher conversion rate through our funnels, giving us more MQLs, more leads to our sales team, and more revenue.”",
    personName: "Andy Mackensen",
    personDesignation: "Co-Founder & CMO",
    ctaURL: "",
    ctaText: "",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-16_2.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-16_2.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "andy-mackensen-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Caroo Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "3 min",
    videoID: "gDLewKa32Sg",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/yellow.webp",
  },
  {
    id: "forter",
    order: 19,
    logo: "forter.png",
    blueLogo: {
      fallBackImage: "forter.png",
      responsiveImages: [
        {
          imageName: "forter.png",
          minBreakpoint: "992px",
        },
        {
          imageName: "forter.png",
          minBreakpoint: "768px",
        },
        {
          imageName: "forter.png",
          minBreakpoint: "320px",
        },
      ],
    },
    alt: "Forter Logo",
    testimonialDescription:
      "“We saw a significant increase in our conversion rates, specifically on our handraised and demo forms.”",
    personName: "Stephen Fiedler",
    personDesignation: "Senior Digital Marketing Manager",
    ctaURL: "",
    ctaText: "See The Forter's Case Study",
    videoPlaceholder: {
      fallBackImage: "review-thumb-desktop-17.webp",
      responsiveImages: [
        {
          imageName: "review-thumb-desktop-17.webp",
          minBreakpoint: "768px",
        },
        // {
        //   imageName: "bill-carney-mobile.webp",
        //   minBreakpoint: "320px",
        // },
      ],
    },
    placeholderAlt: "Forter Video",
    yutubeButton: "play-youtube-2023.svg",
    videoLength: "2 min",
    videoID: "RR_K0SgA4cM",
    bgPattern:
      "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  },
  // {
  //   id: "finquery",
  //   order: 12,
  //   logo: "logos_webp_1.webp",
  //   sourceFolder: `spiralyze2024website`,
  //   cloudinaryPath: `https://res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/`,
  //   blueLogo: {
  //     fallBackImage: "finquery.png",
  //     responsiveImages: [
  //       {
  //         imageName: "finquery.png",
  //         minBreakpoint: "992px",
  //       },
  //       {
  //         imageName: "finquery.png",
  //         minBreakpoint: "768px",
  //       },
  //       {
  //         imageName: "finquery.png",
  //         minBreakpoint: "320px",
  //       },
  //     ],
  //   },
  //   alt: "FinQuery Logo",
  //   testimonialDescription:
  //     "“They make us more agile as an organization … we are getting more conversions on our website … an extension of our team and a great success for us!”",
  //   personName: "Karen Marchione",
  //   personDesignation: "Chief Marketing Officer",
  //   ctaURL: "",
  //   ctaText: "See The FinQuery's Case Study",
  //   videoPlaceholder: {
  //     fallBackImage: "photo_4.webp",
  //     responsiveImages: [
  //       {
  //         imageName: "box-image_17.webp",
  //         minBreakpoint: "768px",
  //       },
  //       // {
  //       //   imageName: "bill-carney-mobile.webp",
  //       //   minBreakpoint: "320px",
  //       // },
  //     ],
  //   },
  //   placeholderAlt: "FinQuery Video",
  //   yutubeButton: "play-youtube-2023.svg",
  //   videoLength: "2 min",
  //   videoID: "wSY2hsvRwf8",
  //   bgPattern:
  //     "//res.cloudinary.com/spiralyze/image/upload/f_auto/spzinternal-website/spiralyze2024website/blue.webp",
  // },
]?.sort((a, b) => a.order - b.order)
